module.exports = __webpack_public_path__ + "static/img/companyContact.feafc1ee.jpg@3x.8bc5e715.png";